import React from 'react'

import logOut from '../../actions/logOut'
import {
  AppAction,
  ExternalLink,
} from '../../styles/links'

const Account = ({auth, history}) => (
  <div>
    <p>
      Signed in as
      {' '}
      <strong>{auth.email}</strong>
      {' - '}
      <AppAction onClick={() => logOut().then( () => history.push(`/`)) }>log out</AppAction>
    </p>

    <p>
      Questions/comments? Need help? Email
      {' '}
      <ExternalLink href="mailto:support@heartstrings.xyz">support@heartstrings.xyz</ExternalLink> [TODO]
    </p>
  </div>
)

export default Account



// WEBPACK FOOTER //
// ./src/views/account/Profile.js